module.exports = __webpack_public_path__ + "assets/img/news (50).d2ef7631.png";